﻿import { Directive } from "@angular/core";

@Directive({
  selector: '.tooltip-content'
})
export class TooltipContentDirective {}